import { Immutable } from "immer";
import React from "react";

import { isoWebPageURL } from "../../models/nominals";
import { FooterWidgets } from "../FooterWidgets";

type IProps = Immutable<{
    phone_number: string;
    show_contact_support: boolean;
    show_nearby_stores: boolean;
    chat_offline_link: string | null;
}>;

export const FooterWidgetsIsland = (props: IProps): React.JSX.Element => {
    const chatOfflineLink = props.chat_offline_link
        ? isoWebPageURL.wrap(props.chat_offline_link)
        : undefined;
    return (
        <FooterWidgets
            phoneNumber={props.phone_number}
            showContactSupportWidget={props.show_contact_support}
            showNearbyStoresWidget={props.show_nearby_stores}
            chatOfflineLink={chatOfflineLink}
        />
    );
};
